import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { getDestinationDetail } from '../../lib/destinations';
import type { Location } from '../../lib/types';
interface Props {
  location: Location;
  selected: boolean;
  onSelect: (id: string) => void;
}
export function LocationCard({
  location,
  selected,
  onSelect
}: Props) {
  const destination = getDestinationDetail(location.id);
  return <motion.button type="button" role="radio" aria-checked={selected} aria-label={`${location.city}, ${location.province}`} onClick={() => onSelect(location.id)} whileTap={{
    scale: 0.98
  }} className={['group relative min-h-32 overflow-hidden rounded-2xl border-2 text-left transition-all', selected ? 'border-[#b78e39] ring-4 ring-[#e5ce91]/60' : 'border-transparent hover:border-[#c6d5c2]'].join(' ')} data-id="element-301" data-mp="1ukl4e8m19obk">
      {destination && <img src={destination.image} alt="" className="absolute inset-0 h-full w-full object-cover transition duration-500 group-hover:scale-105" data-id="element-302" data-mp="566nubl657r5" />}
      <span className="absolute inset-0 bg-gradient-to-r from-[#17362f]/90 via-[#17362f]/55 to-[#17362f]/15" data-id="element-303" data-mp="3qys4jf38m5qd" />
      <span className="relative flex min-h-32 items-center gap-3 p-4 text-white" data-id="element-304" data-mp="3cz98hknpakuf">
        <span className="text-2xl" data-id="element-305" data-mp="3d1d8hrihazpf">{location.emoji}</span>
        <span className="min-w-0 flex-1" data-id="element-306" data-mp="3hwsl6g4r2pk9"><span className="block font-display text-xl font-600" data-id="element-307" data-mp="3i06mrm5lauqn">{location.city}</span><span className="block text-sm text-white/80" data-id="element-308" data-mp="337mr16krrpj8">{location.province}</span></span>
        <span className={['flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 transition-all', selected ? 'border-[#d9b45d] bg-[#d9b45d] text-[#244137]' : 'border-white/80 bg-white/10 text-transparent'].join(' ')} data-id="element-309" data-mp="380pmjk93x922"><CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-310" data-mp="2z7ugwpfq9bbr" /></span>
      </span>
    </motion.button>;
}